"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var noop = function () { };
var GhostSavedBlockItem = function () {
    return (react_1.default.createElement("div", { className: "dashboard-block-library__saved-block-item dashboard-block-library__saved-block-item--ghost" },
        react_1.default.createElement("div", { className: "saved-block-card__outer" },
            react_1.default.createElement("button", { className: "card card--light saved-block-card" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "saved-block-card__inner" },
                        react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: "@", value: "asd", label: "" }, labelHidden: true, isSelected: false, size: kaleidoscope_1.CheckboxSize.Medium, onChange: noop }),
                        react_1.default.createElement("div", { className: "saved-block-card__metadata" },
                            react_1.default.createElement(kaleidoscope_2.GhostBlock, { className: "saved-block-card__block-type saved-block-card__block-type--ghost" }),
                            react_1.default.createElement("div", { className: "saved-block-card__text" },
                                react_1.default.createElement("div", { className: "saved-block-card__name-wrapper" },
                                    react_1.default.createElement(kaleidoscope_2.GhostBlock, { className: "saved-block-card__name saved-block-card__name--ghost" })),
                                react_1.default.createElement("div", { className: "saved-block-card__last-edited" },
                                    react_1.default.createElement(kaleidoscope_2.GhostBlock, { className: "" }))))))))));
};
exports.default = GhostSavedBlockItem;
